import http from '../services/http';

import {
    ONE_EVENT_ENDPOINT,
    ALL_EVENTS_ENDPOINT,
    CREATE_EVENT_ENDPOINT,
    UPDATE_EVENT_ENDPOINT,
    DELETE_EVENT_ENDPOINT,
    ALL_PUBLIC_EVENTS_ENDPOINT,
    DELETE_ATTENDEE_ENDPOINT,
    ADD_ATTENDEE_ENDPOINT,
    UPDATE_ATTENDEE_ENDPOINT,
    EVENT_WEBSITE_DISPLAY_AVAILABLE_POSITIONS,
    ALL_FEATURED_EVENTS_ENDPOINT,
    UPDATE_WEBSITE_DISPLAY_POSITION,
    generateEndpoint
} from '../services/endpoints';

export default (() => {
    
    const getOne = (id) => {

        var endpoint = generateEndpoint(ONE_EVENT_ENDPOINT, { id });

        return http.get(endpoint);
    };

    const getAll = (params) => {

        return http.get(ALL_EVENTS_ENDPOINT, { params });
    };

    const getPublicEvents = (params) => {

        return http.get(ALL_PUBLIC_EVENTS_ENDPOINT, { params });
    };

    const getFeaturedEvents = (params) => {

        return http.get(ALL_FEATURED_EVENTS_ENDPOINT, { params });
    };
    
    const create = (params) => {

        return http.post(CREATE_EVENT_ENDPOINT, params);
    };

    const update = (params) => {

        var endpoint = generateEndpoint(UPDATE_EVENT_ENDPOINT, { id: params.id });

        return http.put(endpoint, params);
    };

    const remove = (eventId) => {

        var endpoint = generateEndpoint(DELETE_EVENT_ENDPOINT, { id: eventId });

        return http.delete(endpoint);
    };

    const deleteAttendee = (attendeeId) => {

        var endpoint = generateEndpoint(DELETE_ATTENDEE_ENDPOINT, { id: attendeeId });

        return http.delete(endpoint);
    };

    const addAttendee = (params) => {

        var endpoint = generateEndpoint(ADD_ATTENDEE_ENDPOINT, { eventId: params.event_id });

        return http.post(endpoint, params);
    };

    const updateAttendee = (params) => {

        var endpoint = generateEndpoint(UPDATE_ATTENDEE_ENDPOINT, { id: params.id });

        return http.put(endpoint, params);
    };

    const getWebsiteAvailablePositions = (params) => {

        return http.get(EVENT_WEBSITE_DISPLAY_AVAILABLE_POSITIONS, { params });
    }

    const updateWebsiteDisplayPosition = (params) => {

        var endpoint = generateEndpoint(UPDATE_WEBSITE_DISPLAY_POSITION, { id: params.id });

        return http.put(endpoint, params);
    }
    
    return {
        create,
        update,
        remove,
        getAll,
        getOne,
        getPublicEvents,
        deleteAttendee,
        addAttendee,
        updateAttendee,
        getWebsiteAvailablePositions,
        getFeaturedEvents,
        updateWebsiteDisplayPosition
    };

})();


// WEBPACK FOOTER //
// ./services/events.js